import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {CommunicationService} from '../../../services/communication.service';
import {HasSubscriptions} from '../../has-subscriptions';
import {MyRemaxModes} from '../../../classes/enums';
import {SearchResult} from '../search-bar.component';
import {Listing} from '../../../classes/listing';
import {PreferencesService} from '../../../services/preferences.service';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: [
    './search-results.component.scss',
    './search-results.desktop.component.scss'
  ]
})
export class SearchResultsComponent extends HasSubscriptions implements OnInit {
  @ViewChild('resultListRef') listResultsRef: ElementRef;
  @Input('recentSearches') recentSearches: Array<string> = [];
  @Input() searchInput: string = '';
  @Input() isSearchingForResults: boolean = false;
  @Input() showButtons: boolean = true;


  @Input() locationResults: SearchResult[] = [];
  @Input() listingResults: SearchResult[] = [];
  @Input() mlsMatchResults: SearchResult[] = [];


  @Output() onBlur: EventEmitter<void> = new EventEmitter<void>();
  @Output() selectResult: EventEmitter<SearchResult> = new EventEmitter<SearchResult>();
  @Output() favouriteClick: EventEmitter<Listing> = new EventEmitter<Listing>();
  constructor(
    private __preferencesService: PreferencesService,
    private _communicationService: CommunicationService,
    private _router: Router
  ) { super(); }

  ngOnInit() {}

  onCenterAtMyLocation() {
    this.__preferencesService.centerMapAtCurrentLocation(false, true);
    this._communicationService.toolbar.filtersRequested.next();
  }

  onSavedSearchesClick($event) {
    this._router.navigate(['/my-remax'], {queryParams: { mode: MyRemaxModes.SAVED_SEARCHES }});
    this._communicationService.navigation.showSearch.next(false);
  }

  trackBy(index, elem: SearchResult) {
    return elem.id;
  }

  // TODO: key press enter

}
